import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import CustomFieldModal from "../customFieldsModal";
import {
  ACTIONS_LIST,
  CUSTOM_RENDER_KEYS,
  LIST_HEADERS,
  PERMS_FOR_ACTIONS,
} from "./constants";
import CustomFieldCard, {CustomRenderComponent} from "./customFieldCard";
import {useCustomFieldsTableActions} from "./useTableActions";
import {useCustomFieldsTableData} from "./useTableData";

const CustomFieldTable = () => {
  const {
    deleteModalStatus,
    deleteCustomField,
    editModalStatus,
    handleActionSelection,
    selectedCustomField,
    setDeleteModalStatus,
    setEditModalStatus,
  } = useCustomFieldsTableActions();
  const {paginationConfig, customFieldsList, customFieldsTotalCount} =
    useCustomFieldsTableData();

  return (
    <Fragment>
      {editModalStatus && (
        <CustomFieldModal
          data={selectedCustomField}
          onCancel={() => setEditModalStatus(false)}
          open={editModalStatus}
        />
      )}
      {deleteModalStatus && (
        <DeleteModal
          header={"Delete Custom Field"}
          modalBody={"Are you sure you want to delete this custom field?"}
          onClose={() => setDeleteModalStatus(false)}
          onDelete={deleteCustomField}
          open={deleteModalStatus}
        />
      )}
      <div className="table-container">
        <ListView
          actionsList={ACTIONS_LIST}
          cardContent={CustomFieldCard}
          customRenderKeys={CUSTOM_RENDER_KEYS}
          customRenderComponent={CustomRenderComponent}
          listItems={customFieldsList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={customFieldsTotalCount}
          withActions
          withPagination={paginationConfig}
        />{" "}
      </div>
    </Fragment>
  );
};

export default CustomFieldTable;
